import React from "react";
import { Link, useParams } from "react-router-dom";

export default function Header({
  generateImg,
  generateDisable,
  handleExportPage,
  handleDesignPage
}) {


  const { id } = useParams();


  return (
    <>
      <div class="artboard--main__header--center">
        <div class="artboard--main__tabs">
          <Link onClick={handleDesignPage} to={`/design/${id}`} class="artboard--main__tabs--nav__item">
            Design
          </Link>
          <a href="#" class="artboard--main__tabs--nav__item active">
            Variation
          </a>
          <Link
            onClick={() => {
              handleExportPage();
            }}
            class="artboard--main__tabs--nav__item"
          >
            Export
          </Link>
        </div>
      </div>
      {/* <div class="artboard--main__header--right">
        <button
          className="float-end  btn btn-primary"
          onClick={() => {
            handleExportPage();
          }}
          disabled={generateDisable ? true : false}
        >
          <img src={generateImg} />
          Generate
        </button>
      </div> */}
    </>
  );
}
